import React, { useContext } from 'react'
import { Box } from '@fedsim/components'
import { useNavigate } from 'react-router-dom'
import { backgroundImage, backgroundSize } from "@fedsim/constants";

import Dev from 'pages/dev';
import QuickLook from './quick-look'
import Logo from 'components/fsx-logo'
import Drawer from './drawer'
import { trackEv, Categories, Actions } from 'analytics'

import { ToggleMode, ColorModeContext } from './color-mode'

const LOCATION = '/office';

export function Topbar() {
  const navigate = useNavigate()
  const colorMode = useContext(ColorModeContext);
  const logoVariant = colorMode.mode === 'dark' ? 2 : 3;
  const onGoOffice = () => {
    trackEv(Categories.Topbar, Actions.Navigate, { label: "LOGO" })

    navigate(LOCATION)
  }
  return (
    <Box
      elevation={4}
      sx={{
        // position: 'fixed',
        // top: 0,
        // width: '100%',
        alignItems: "center",
        display: "flex",
        paddingY: '5px',
        justifyContent: "space-between",
        background: theme => theme.palette.background.header,
        backgroundImage,
        backgroundSize,
        transition: "all .5s ease",
        padding: {
          xs: "2px 18px",
          sm: "2px 18px",
          md: "2px 18px",
          lg: "3px 24px"
        }
      }}
    >
      <Box onClick={onGoOffice}
        sx={{
          borderRadius: '50%',
          // backgroundColor: '#777',
          p: 1,
          '&:hover': {
            // backgroundColor: '#000',
            cursor: 'pointer'
          }
        }}>
        <Logo variant={logoVariant} height={40} />
      </Box>
      <Box sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end',
      }}>
        <QuickLook />
        <ToggleMode />
      </Box>
      <Box>
        <Drawer />
      </Box>
      <Dev />
    </Box>
  )
}

export default Topbar
